module.exports = __webpack_public_path__ + "static/media/1012261.99c23571.jpg";